import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { _className, ComponentSync } from '@nu-art/thunderstorm-frontend/index';
import './AdvisorPanelResizer.scss';
import { ModuleFE_EMInterface } from '@app/advisor-frontend';
export class AdvisorPanelResizer extends ComponentSync {
    __onPathwayEndUpdated() {
        // if no protocol has ended ignore
        if (!ModuleFE_EMInterface.isPostDisposition())
            return;
        // update the component
        this.forceUpdate();
    }
    deriveStateFromProps(nextProps, state) {
        // @ts-ignore
        state.panelKey ??= React.Children.toArray(this.props.children)[0].props.panelKey;
        state.height = nextProps.height;
        state.paddingTop = nextProps.paddingTop;
        state.paddingBottom = nextProps.paddingBottom;
        return state;
    }
    render() {
        const className = _className('advisor-panel-resizer', ModuleFE_EMInterface.isPostDisposition() && 'hide-shadow');
        return _jsx("div", { className: className, style: {
                maxHeight: `${this.state.height}px`,
                paddingTop: `${this.state.paddingTop}px`,
                paddingBottom: `${this.state.paddingBottom}px`,
            }, children: this.props.children });
    }
}
//# sourceMappingURL=AdvisorPanelResizer.js.map